import cls from "classnames";
import styles from "./index.module.scss";

const AiContentTip = ({ className }: { className?: string }) => {
  //回头弄国际化和香港环境的事
  return <div className={cls(styles.container, className)}>由商量AI生成</div>;
};

export default AiContentTip;
